// extracted by mini-css-extract-plugin
export default {"icon":"erp-product-tag_icon__zYKLO"};